import { render, staticRenderFns } from "./KnowYourCustomer.vue?vue&type=template&id=4dc802b9&scoped=true&"
import script from "./KnowYourCustomer.vue?vue&type=script&lang=ts&"
export * from "./KnowYourCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./KnowYourCustomer.vue?vue&type=style&index=0&id=4dc802b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc802b9",
  null
  
)

export default component.exports